module.exports = __webpack_public_path__ + "static/img/justeat_gestion.f87c971.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/justeat_gestion.png
// module id = 00Sx
// module chunks = 4